import React from 'react';

type RoundedRowProps = {
  children: React.ReactNode;
};

const RoundedRow = ({ children }: RoundedRowProps) => {
  return (
    <div className="tw-flex tw-h-[30px] tw-flex-1 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-[5px] tw-bg-[#232589] lg:tw-h-[34px] lg:tw-rounded-[10px]">
      {children}
    </div>
  );
};

export default RoundedRow;
